<p-autocomplete [ngModel]="displayValue()" (ngModelChange)="onModelChange($event)" [suggestions]="filteredLccas()"
    (completeMethod)="searchLccas($event)" (onSelect)="onLccaSelect($event)" (onClear)="onClear()" [dropdown]="true" dropdownMode="current"
    [forceSelection]="false" [minLength]="minLength" [placeholder]="placeholder()" [disabled]="disabled()"
    [showClear]="true" styleClass="w-full text-sm">
    <ng-template let-lcca pTemplate="item">
        <div class="flex flex-col">
            <span class="font-medium">{{lcca.maintenance_detail}}</span>
            <span *ngIf="lcca.lcca_code" class="text-xs text-gray-500">{{lcca.lcca_code}}</span>
        </div>
    </ng-template>
</p-autocomplete>
